import React from 'react';

const multiItemQuestion = (WrappedComponent, template) => {
    const MultiItemComponent = props => {
        const handleAddItemStateArray = async e => {
            let newArray = [...props.items, { ...template }];
            props.setter(newArray);
        };
        const handleRemoveItemStateArray = removeIndex => e => {
            let remainingData = [...props.items];
            remainingData.splice(removeIndex, 1);
            props.setter(remainingData);
        };
        const handleStateArrayItemChange = (index, field, newValue) => e => {
            let modifiedData = props.items.map(
                (data, i) => {
                    if (i === index) {
                        data[field] = newValue !== undefined ? newValue : e.target.value;
                        if(data["yearFrom"]===null){
                            data["yearFrom"]="";
                        }
                        if(data["yearFrom"]){
                            data[field] = newValue !== undefined ? newValue : e.target.value;
                        }
                        if(data["yearTo"]!=="" && data["yearTo"]<data["yearFrom"]){
                            data["yearTo"]="";
                            data["yearFrom"]="";
                        }
                        if (data?.method !== "Other" && data?.otherMethod) {
                            data.otherMethod = '';
                            // data.yearFrom = '';
                            // data.yearTo = '';
                        }
                        else if (data[field] === "None") {
                            data.yearFrom = '';
                            data.yearTo = '';
                        }
                    }
                    return data;
                }
            );
            props.setter(modifiedData);
        };

        return <WrappedComponent
            onAdd={handleAddItemStateArray}
            onRemove={handleRemoveItemStateArray}
            onChange={handleStateArrayItemChange}
            {...props}
        />

    };

    return MultiItemComponent;
};

export default multiItemQuestion;